module.exports = __webpack_public_path__ + "static/og-fa97be221a4450ebf58596bbde12f622.png";